import regiondata from './RegionData';
import councildata from './CouncilData';

const networkData = {
  colours: councildata.colours,
  councils: councildata.councils,
  stateHighways: regiondata.stateHighways,
  regions: regiondata.regions,
};

export default networkData;
